import React, {Component} from 'react';
import {Image, Button, Card, Divider, Form, Input, Modal} from "antd";
import {LockOutlined, UserOutlined} from "@ant-design/icons";
import {authApiService} from "../../services/otodis/AuthApiService";
import ReCAPTCHA from "react-google-recaptcha";
import Cookies from 'universal-cookie';
import {withRouter} from "../../hoc/withRouter";

// import {getToken} from '../../services/firebase/messaging';

export interface LoginOldProps {

}

export interface LoginOldStates extends LoginOldFields {
    processing: boolean;
    captchaSuccess: boolean,
}

export interface LoginOldFields {
    username: string;
    password: string;
    pushToken: string
}

class LoginOld extends Component<LoginOldProps & any, LoginOldStates> {
    private cookies = new Cookies();

    constructor(props: LoginOldProps & any) {
        super(props);

        this.state = {
            processing: false,
            captchaSuccess: false,
            password: "",
            username: "",
            pushToken: "",
        }
    }

    onFieldChange = <T extends keyof LoginOldFields>(target: T, value: string) => {
        const currentState: any = {...this.state};
        switch (target) {
            case "username":
                currentState.username = value;
                break;
            case "password":
                currentState.password = value;
                break;
        }

        this.setState({
            ...currentState,
        })
    }

    onCaptchaChange = () => {
        this.setState({
            captchaSuccess: true,
        })
    }

    onCaptchaExpire = () => {
        this.setState({
            captchaSuccess: false,
        })
    }

    onErrored = () => {
        this.setState({
            captchaSuccess: true,
        })
    }

    submit = async () => {
        this.setState({
            processing: true,
        })

        try {
            const login = await authApiService.login({
                username: this.state.username,
                password: this.state.password,
                app_code: "otodis",
                token_notification: this.state.pushToken,
            });

            const access_project = login.data.data.access_project;
            const dealerData: any = [];
            for (let item of access_project) {
                dealerData.push({
                    DealerCode: item.project_code,
                    DealerName: item.project_name
                });
            }
            const dealer_default = {
                DealerCode: login.data.data.default_project.project_code,
                DealerName: login.data.data.default_project.project_name
            }

            await this.cookies.set('_t', login.data.data.token);
            await this.cookies.set('_u', Buffer.from(JSON.stringify(login.data.data.name)).toString('base64'));
            await this.cookies.set('_d', Buffer.from(JSON.stringify(dealerData)).toString('base64'));
            await this.cookies.set('_dd', Buffer.from(JSON.stringify(dealer_default)).toString('base64'));
            await this.cookies.set('_am', Buffer.from(JSON.stringify(login.data.data.access_menu)).toString('base64'));

            await authApiService.setToken(login.data.data.token);
            await this.promisedSetState({
                processing: false,
            });

            // setTimeout(() => {
            this.props.history.push('/' + dealer_default.DealerCode.replace(/#/g, '-') + '/dashboard');
            // }, 400);

            // window.location.href = '/';
        } catch (e) {
            Modal.error({
                title: 'Login Failed',
                content: 'Username atau password tidak cocok',
            });

            this.setState({
                processing: false,
            });
        }
    }

    componentDidMount() {
        // getToken().then(r => {
        //     this.setState({
        //         pushToken: r
        //     })
        // });
    }

    promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

    render() {
        return (
            <Card style={{marginTop: 100}}>
                <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                    <Image src="/assets/img/logootodis.png"/>
                </div>
                <Divider/>
                <Form style={{margin: 10}}>
                    <Form.Item>
                        <Input prefix={<UserOutlined/>} placeholder={'Username'} size={'large'}
                               value={this.state.username}
                               onChange={event => this.onFieldChange("username", event.target.value)}
                        />
                    </Form.Item>
                    <Form.Item
                    >
                        <Input prefix={<LockOutlined/>} type={'password'} placeholder={'Password'} size={'large'}
                               value={this.state.password}
                               onChange={event => this.onFieldChange("password", event.target.value)}
                        />
                    </Form.Item>

                    <div style={{margin: '25px 0'}}>
                        {
                            this.state.captchaSuccess && <Button onClick={this.submit} loading={this.state.processing} type={'primary'} htmlType={'submit'} style={{width: "100%"}} size={'large'}> Login</Button>
                        }
                    </div>

                    <div style={!this.state.captchaSuccess ? {} : {display: 'none'}}>
                        <ReCAPTCHA
                            sitekey={'6Ldw1lsaAAAAAIPSAP_2Ivl1VXPeY8fOEvEsYQS9'}
                            onChange={this.onCaptchaChange}
                            onExpired={this.onCaptchaExpire}
                            onErrored={this.onErrored}
                        />
                    </div>

                </Form>
            </Card>
        );
    }
}

export default withRouter(LoginOld);
